import { Container } from 'components/gruenland/atoms/container/Container';
import { AmericanExpress } from 'components/svgr/AmericanExpress';
import { Mastercard } from 'components/svgr/Mastercard';
import { Paypal } from 'components/svgr/Paypal';
import { Visa } from 'components/svgr/Visa';
import AverageRatings from 'components/yggdrasil/organisms/feedaty/AverageRatings';
import { SocialLinkIcons } from './atoms/SocialLinkIcons';
import MarketButton from '../market-button/MarketButton';

export const FooterReviews: React.FC = () => {
  return (
    <div className="bg-neutrals-black text-white">
      <Container className="py-4">
        <div className="flex flex-col flex-wrap gap-[15px] md:flex-row md:items-center md:justify-between">
          <div className="flex w-full flex-col gap-[15px] sm:flex-row sm:justify-between">
            <MarketButton className="flex items-center gap-3" />
            <SocialLinkIcons className="flex md:hidden" />
          </div>
          <AverageRatings />
          <div className="grid grid-cols-1 items-center sm:flex sm:gap-6">
            <Visa />
            <Mastercard />
            <AmericanExpress />
            <Paypal />
          </div>
        </div>
      </Container>
    </div>
  );
};
